import styled from 'styled-components';

// Selectors 
export const StyledSelector = styled.select<{display?: string; width?: string; padding?: string; font_size?:string; text_align?:string; margin?: string; margin_top?: string }>`
    
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    
    display: ${props => !props.display? 'block' : props.display};
    justify-content: left;    
    width: ${props => !props.display? '80px' : props.display};   
    height: 35px;
    float: right;
    padding:  ${props => !props.padding? '0 10px' : props.padding};
    font-size:  ${props => !props.font_size? '16px' : props.font_size};
    line-height: 1.75;
    color: #333;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #cccccc;
    border-radius: 35px;
    text-align:  ${props => !props.text_align? 'center' : props.text_align};
    margin: ${props => !props.margin? '0 auto' : props.margin};
    margin-top: ${props => !props.margin_top? 'auto' : props.margin_top};

`;

export const StyledOption = styled.option`
    background: #FFF;    
`;

export const StyledRepeatSelector = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

export const StyledDaySelect = styled.span<{selected: boolean}>`
    display: inline-block;
    width: 30px;
    height: 30px;
    border-radius: 15px;
    background: ${props => props.selected? '#233567' : '#FFF'};
    text-align: center;
    color: ${props => props.selected? '#FFF' : '#233567'};
    border: 1px solid #233567;
    line-height: 30px;
    margin: 0 1px;

    &:hover {
        cursor: pointer;
    }
`;

export const StyledVerticalSelectItem = styled.div<{ selected: boolean }>`
  padding: 5px 10px;
  display: flex;
  color: ${props => props.selected? '#FFFFFF' : '#292D34'};
  background: ${props => props.selected? '#233567' : '#FFFFFF'};
`;

export const StyledWrxSelector = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const WrxSelect = styled.span<{selected: boolean}>`
  display: inline-block;
  width: 100px;
  height: 30px;
  border-radius: 15px;
  background: ${props => props.selected? '#233567' : '#FFF'};
  text-align: center;
  color: ${props => props.selected? '#FFF' : '#233567'};
  border: 1px solid #233567;
  line-height: 30px;
  margin: 0 1px;
    
  &:hover {
    cursor: pointer;
  }
`;

